import { styled, Theme } from '@mui/material';

export const sxStyles = {
  wrap: {
    marginBottom: '2rem',
  },
  title: (theme: Theme) => ({
    marginBottom: '1rem',
    color: theme.palette.primary.main,
  }),
};

export const StyledProgramsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '2rem',

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));
